import { useContext } from 'react';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import InputConfig from '../../../../../Components/InputConfig';
import DropDownSingle from '../../../../../Components/DropDownSingle';
//mui imports====
import useCommonStyles from '../../../../../commonStyles';
import { Grid, Typography } from '@mui/material';
//===============
import FormatDataConstants from '../constants.json';
const { PLAYER_UI_MODES } = FormatDataConstants;

const DeviceConfig = ({ keyData, deviceName, playerUiMode }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	const closeButtonPlatformKeyData =
		playerUiMode === PLAYER_UI_MODES.INCONTENT
			? `formatData.inContentCloseBtnPosition.${deviceName.toUpperCase()}`
			: 'formatData.closeBtnPosition' + '.' + deviceName.toUpperCase();

	const closeButtonEnabledKeyData =
		playerUiMode === PLAYER_UI_MODES.INCONTENT
			? 'formatData.inContentCloseBtnPosition.enabled'
			: null;

	const isCloseButtonInputEnabled = !!(
		playerUiMode === PLAYER_UI_MODES.FLOATING ||
		(playerUiMode === PLAYER_UI_MODES.INCONTENT && rawConfig[closeButtonEnabledKeyData])
	);

	return (
		<Grid
			container
			spacing={2}
			className={commonStyleClasses.basicOutlinedBox}
			style={{ width: '95%', margin: '3rem 0 3rem 4.5rem', paddingBottom: '3rem' }}
		>
			<Grid item xs={12}>
				<Typography variant="h4" fontWeight={600} style={{ marginBottom: '1rem' }}>
					{deviceName[0].toUpperCase() + deviceName.slice(1).toLowerCase()}
				</Typography>
			</Grid>
			{playerUiMode === PLAYER_UI_MODES.INCONTENT && (
				<Grid item xs={3}>
					<InputConfig
						keyData={keyData + '.rightPosition'}
						label="Right Position"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
					/>
				</Grid>
			)}
			{playerUiMode === PLAYER_UI_MODES.FLOATING && (
				<Grid item xs={3}>
					<InputConfig
						keyData={keyData + '.rightPositionPip'}
						label="Right Position Pip"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
						batchUpdateForObjectEditor={[{ key: keyData + '.leftPositionPip', value: 'auto' }]}
					/>
				</Grid>
			)}
			{playerUiMode === PLAYER_UI_MODES.INCONTENT && (
				<Grid item xs={3}>
					<InputConfig
						keyData={keyData + '.leftPosition'}
						label="Left Position"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
					/>
				</Grid>
			)}
			{playerUiMode === PLAYER_UI_MODES.FLOATING && (
				<Grid item xs={3}>
					<InputConfig
						keyData={keyData + '.leftPositionPip'}
						label="Left Position Pip"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
						batchUpdateForObjectEditor={[{ key: keyData + '.rightPositionPip', value: 'auto' }]}
					/>
				</Grid>
			)}
			{playerUiMode === PLAYER_UI_MODES.FLOATING && (
				<Grid item xs={3}>
					<InputConfig
						keyData={keyData + '.bottomPositionPip'}
						label="Bottom Position Pip"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
						batchUpdateForObjectEditor={[{ key: keyData + '.topPositionPip', value: 'auto' }]}
					/>
				</Grid>
			)}
			{playerUiMode === PLAYER_UI_MODES.FLOATING && (
				<Grid item xs={3}>
					<InputConfig
						keyData={keyData + '.topPositionPip'}
						label="Top Position Pip"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
						batchUpdateForObjectEditor={[{ key: keyData + '.bottomPositionPip', value: 'auto' }]}
					/>
				</Grid>
			)}
			{playerUiMode === PLAYER_UI_MODES.INCONTENT && (
				<Grid item xs={3}>
					<InputConfig
						keyData={keyData + '.zIndex'}
						label="Z Index"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
					/>
				</Grid>
			)}
			{playerUiMode === PLAYER_UI_MODES.FLOATING && (
				<Grid item xs={3}>
					<InputConfig
						keyData={keyData + '.zIndexPip'}
						label="Z Index Pip"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
					/>
				</Grid>
			)}

			<Grid item xs={3}>
				<DropDownSingle
					keyData={closeButtonPlatformKeyData}
					label="Close Button Position"
					list={['top-left', 'top-right', 'bottom-left', 'bottom-right']}
					formControlVariant="outlined"
					object={rawConfig}
					updateObject={updateRawConfig}
					disabled={!isCloseButtonInputEnabled}
					isMandatory
				/>
			</Grid>
		</Grid>
	);
};
export default DeviceConfig;
